import { typedAction } from "../helpers";
import { SET_SAVE_FORMAT_OVERRIDE } from "./actionTypes";
import { SaveFormat } from "../../components/enums/SaveFormatEnum";

// The user's explicit per-save "Save format" pick. null = no pick made yet: the
// effective format then falls back to the persisted default derived from
// settings.convertEmailToPDF. Resolution lives in useSaveFormat — components
// must read the effective format through that hook, never this slice directly.
export interface SaveFormatState {
    override: SaveFormat | null;
}

const initialState: SaveFormatState = { override: null };

export const setSaveFormatOverride = (override: SaveFormat | null) => {
    return typedAction(SET_SAVE_FORMAT_OVERRIDE, override);
};

type SaveFormatAction = ReturnType<typeof setSaveFormatOverride>;

export function saveFormatReducer(state = initialState, action: SaveFormatAction): SaveFormatState {
    switch (action.type) {
        case SET_SAVE_FORMAT_OVERRIDE:
            // Identity-stable no-op: reset fires on navigation effects, so an
            // unchanged override must not produce a new state object (it would
            // re-render every useSaveFormat consumer).
            return state.override === action.payload ? state : { override: action.payload };
        default:
            return state;
    }
}
